import * as actions from '../../actions/actionTypes';

const initialState = {
  showOnOffList: [],
};

export default function channelMapHiddenData(state = initialState, action) {
  switch (action.type) {
    case actions.SET_CHANNEL_MAPPING_HIDDEN_DATA:
      return action.payload;
    default:
      return state;
  }
}
